// @ts-check
import {Toggle} from '@/components-v2/atoms'
import {Dropdown, SectionTitle, TextArea, TextInput} from '@/components-v2/molecules'
import {PromotionImageUpload} from './PromotionImageUpload'
import {DISPLAY_ORDER_OPTIONS, LOCATION_OPTIONS} from '@/utils/constants/promotionConstants.js'
import {usePromotionBannerUpload} from './usePromotionBannerUpload'
import {usePromotionDisplay} from './usePromotionDisplay'
import './_PromotionDisplay.scss'


export const PromotionDisplayStep = () => {
  const {handleBannerUpload} = usePromotionBannerUpload()
  const {
    promotion,
    languages,
    displayFirst,
    bannerTypeOptions,
    landingPageOptions,
    showsOnPlaceholder,
    getDisplayOnValue,
    getDisplayOrderValue,
    getBannerTypeValue,
    getLandingPageValue,
    handleTextChange,
    handleDropdownChange,
    handleDisplayFirstChange,
  } = usePromotionDisplay()

  return (
    <div className="mt-4 rounded-lg p-4">
      {/* Banner Section */}
      <div className="flex flex-col gap-6 rounded-lg bg-[var(--color-background-layer-01)] p-6">
        <h3 className="text-lg font-semibold">Promotion Banner</h3>

        <PromotionImageUpload onImageSelect={handleBannerUpload} value={promotion?.bannerUrl} title={'Promotion Image*'} />

        <div className="flex flex-row items-end gap-6">
          <Dropdown
            childList={LOCATION_OPTIONS}
            label="Promotion Shows On"
            placeholder={showsOnPlaceholder || 'Select Option'}
            selection="multiple"
            size="medium"
            selectedValue={getDisplayOnValue()}
            setSelectedValue={value => handleDropdownChange('displayOn', value)}
          />

          <Dropdown
            childList={bannerTypeOptions}
            isClearable={false}
            label="Banner Type"
            placeholder="Select Banner Type"
            selection="single"
            size="medium"
            selectedValue={getBannerTypeValue()}
            setSelectedValue={value => handleDropdownChange('bannerType', value)}
          />
          {promotion.bannerType === 'clickable' && (
            <Dropdown
              childList={landingPageOptions}
              isClearable={false}
              label="Landing Page *"
              placeholder="Select Landing Page"
              selection="single"
              size="medium"
              selectedValue={getLandingPageValue()}
              setSelectedValue={value => handleDropdownChange('landingPage', value)}
            />
          )}
          
        </div>

        <div className="pb-1">
            <Toggle
              label="Display First"
              value="Yes"
              checked={displayFirst}
              size="medium"
              variant="horizontal"
              onUpdate={handleDisplayFirstChange}
            />
          </div>
          {!displayFirst && (
            <Dropdown
              childList={DISPLAY_ORDER_OPTIONS}
              label="Display Order"
              placeholder="Display Order"
              selection="single"
              size="medium"
              selectedValue={getDisplayOrderValue()}
              setSelectedValue={value => handleDropdownChange('displayOrder', value)}
            />
          )}

        {/* <div className="flex flex-row gap-6">
          <Dropdown
            childList={routeTypeIdOptions}
            isClearable={false}
            label="Route Type ID"
            placeholder="Select Route Type ID"
            selection="single"
            size="medium"
            selectedValue={routeTypeIdSelected}
            setSelectedValue={value => handleDropdownChange('routeTypeId', value)}
          />
        </div> */}

        <div className="flex flex-row gap-6">
          
        </div>

        <div className="border-t border-t-[var(--color-border-default)]"></div>

        {/* Text Section */}
        <SectionTitle label="Promotion Text" />

        <div className="grid grid-cols-3 gap-4">
          {languages.map(lang => {
            const language = lang.code

            return (
              <div key={language} className="space-y-5">
                <h3 className="font-semibold">{lang.language}</h3>
                <TextInput
                  label="Product Tag*"
                  onUpdate={value => handleTextChange(value, language, 'productTag')}
                  placeholderText="10% Discount"
                  value={promotion?.text?.[language]?.productTag || ''}
                />
                <TextInput
                  label={'Banner Tag*'}
                  onUpdate={value => handleTextChange(value, language, 'bannerTag')}
                  placeholderText="10% Discount"
                  value={promotion?.text?.[language]?.bannerTag || ''}
                />
                <TextInput
                  label="Excerpt"
                  onUpdate={value => handleTextChange(value, language, 'excerpt')}
                  placeholderText="Excerpt"
                  value={promotion?.text?.[language]?.excerpt || ''}
                />
                <TextInput
                  label="Title*"
                  onUpdate={value => handleTextChange(value, language, 'title')}
                  placeholderText="Get 10% off when buying any 5 Lays or Doritos"
                  value={promotion?.text?.[language]?.title || ''}
                />
                <TextArea
                  label="Description"
                  maxLength={500}
                  onUpdate={value => handleTextChange(value, language, 'description')}
                  value={promotion?.text?.[language]?.description || ''}
                  placeholder="Type here"
                  showCharacterCount={false}
                  showToolbar={false}
                />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
